import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CircleAlert } from 'lucide-react';
import DeleteCashierApi from "../../../services/cashier/deleteCashier.js";
import { toast } from 'react-toastify';
import handleErrorToast from '../../../utils/handleErrorToasts.js';
import CASHIER_TOASTS from '../../../utils/constants/toastMesages/cashierToastMessage.js';

/**
 * Modal component to confirm and delete a cashier.
 *
 * @param {Object} props
 * @param {boolean} props.show - Controls visibility of the modal.
 * @param {function} props.onHide - Callback to close the modal.
 * @param {Object} props.cashier - Cashier object to delete (expects `_id`).
 * @returns {JSX.Element} The delete confirmation modal.
 */
function DeleteCashierModal({ show, onHide, cashier }) {
  
  // Handler to delete cashier via API call
  const deleteCashier = async () => {
    try {
      await DeleteCashierApi(cashier._id);
      toast.success(CASHIER_TOASTS.CASHIER_DELETED);
      onHide(); // Close the modal after deletion
    } catch (error) {
      toast.error(CASHIER_TOASTS.CASHIER_NOT_DELETED)
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="d-flex flex-column align-items-center text-center">
        <h5 className="mb-3">Are you sure you want to delete this cashier?</h5>

        <div className="mb-4">
          <CircleAlert size={48} className="text-danger" />
        </div>

        <div className="d-flex justify-content-center gap-3">
          <Button variant="secondary" onClick={onHide}>
            No
          </Button>
          {/* Trigger the deleteCashier function on click */}
          <Button variant="danger" onClick={deleteCashier}>
            Yes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default DeleteCashierModal;
